import { render } from "./EscritorioCitasConfirmadas.vue?vue&type=template&id=24a70195"
import script from "./EscritorioCitasConfirmadas.vue?vue&type=script&lang=js"
export * from "./EscritorioCitasConfirmadas.vue?vue&type=script&lang=js"

import "./EscritorioCitasConfirmadas.vue?vue&type=style&index=0&id=24a70195&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__